import { french as domainFrench } from '~domain/i18n/french';
import { BaseTranslationKeys } from '~frontend-common/i18n/english';
import additionalDriver from '~frontend-common/i18n/french/additional-driver-subquestions.i18n';
import autoGeneratedHelper from '~frontend-common/i18n/french/auto-generated-helper.i18n';
import baseSegment from '~frontend-common/i18n/french/base-segment.i18n';
import businessOccupancy from '~frontend-common/i18n/french/business-occupancy.i18n';
import carCreditor from '~frontend-common/i18n/french/car-creditor.i18n';
import carDetails from '~frontend-common/i18n/french/car-details-subquestion.i18n';
import carsDriverAssignments from '~frontend-common/i18n/french/cars-driver-assignments-subquestions.i18n';
import choices from '~frontend-common/i18n/french/choices.i18n';
import claims from '~frontend-common/i18n/french/claim-subquestions.i18n';
import confirmationForm from '~frontend-common/i18n/french/confirmation-form.i18n';
import continuouslyCoverage from '~frontend-common/i18n/french/continuously-coverage-subquestion.i18n';
import core from '~frontend-common/i18n/french/core.i18n';
import coverage from '~frontend-common/i18n/french/coverage.i18n';
import disclaimer from '~frontend-common/i18n/french/disclaimer.i18n';
import driverLicenceDetails from '~frontend-common/i18n/french/driver-licence-details.i18n';
import drivingConvictions from '~frontend-common/i18n/french/driving-convictions-subquestions.i18n';
import electricalDetails from '~frontend-common/i18n/french/electrical-details.i18n';
import error from '~frontend-common/i18n/french/error.i18n';
import faq from '~frontend-common/i18n/french/faq.i18n';
import financialInstitution from '~frontend-common/i18n/french/financial-institution.i18n';
import garage from '~frontend-common/i18n/french/garage-subquestion.i18n';
import homeAmenities from '~frontend-common/i18n/french/home-amenities.i18n';
import homeStructureCondition from '~frontend-common/i18n/french/home-structure-condition.i18n';
import moveInDetails from '~frontend-common/i18n/french/move-in-details.18n';
import occupation from '~frontend-common/i18n/french/occupation.i18n';
import padPayment from '~frontend-common/i18n/french/pad-payment.i18n';
import policies from '~frontend-common/i18n/french/policies.i18n';
import pool from '~frontend-common/i18n/french/pool-subquestion.i18n';
import propertyCharacteristics from '~frontend-common/i18n/french/property-characteristics.i18n';
import receipt from '~frontend-common/i18n/french/receipt.i18n';
import redirectionPartner from '~frontend-common/i18n/french/redirection-to-partner.i18n';
import suggestion from '~frontend-common/i18n/french/suggestion.i18n';
import validation from '~frontend-common/i18n/french/validation.i18n';

export const french: BaseTranslationKeys = {
  ...autoGeneratedHelper,
  ...additionalDriver,
  ...businessOccupancy,
  ...suggestion,
  ...baseSegment,
  ...carDetails,
  ...carsDriverAssignments,
  ...occupation,
  ...choices,
  ...claims,
  ...confirmationForm,
  ...continuouslyCoverage,
  ...core,
  ...disclaimer,
  ...drivingConvictions,
  ...electricalDetails,
  ...garage,
  ...faq,
  ...homeStructureCondition,
  ...homeAmenities,
  ...validation,
  ...financialInstitution,
  ...moveInDetails,
  ...padPayment,
  ...pool,
  ...propertyCharacteristics,
  ...redirectionPartner,
  ...carCreditor,
  ...policies,
  ...driverLicenceDetails,
  receipt: {
    common: receipt.receipt,
  },
  error: {
    common: error.error,
  },
  coverage: {
    common: coverage.coverage,
  },
  carriers: domainFrench.carriers,
};
